export default function ErrorPage () {
    return (<>        
        <div className="container-sm App_container">
            <div className="col-sm-12 col-md-10 col-lg-10 col-xl-10 col-xxl-12" id="">
            
            <h1 className="text-center">Error Page: Something Happen</h1>
            </div>
        
      
        </div>
        </>
    )
}